<!--
 * @Description: (弹框)商户验证组件
 * @Author: gaohc
 * @Date: 2022-10-10 16:43:52
-->
<template>
  <div class="drawer-wrap">
    <el-drawer :size="996" title="账户验证" :before-close="handleCancel" :visible.sync="visible"
      direction="rtl" @open="initData">
      <div class="review-result-wrap" v-if="validationData && validationData.review">
        <review-history :review="validationData.review"></review-history>
      </div>
      <div class="signing-qrcode-wrap">
        <div class="title">账户验证</div>
        <div>你可以按照指引，选择任意一种方式验证</div>
        <div>
          <span>【方式一】请在{{ validationData.deadline }} 前使用法人</span>
          <span class="tag-text">{{ validationData.legalPersonName }}</span>
          <span> 的微信扫码确认</span>
        </div>
        <div class="qr-code-wrap">
          <el-image class="qr-code" :src="validationData.verifyPhotoBase"></el-image>
        </div>
        <div style="padding-right: 100px">
          <span>【方式二】请在{{ validationData.deadline }} 前使用 </span>
          <span class="tag-text">{{ validationData.accountName }}</span>
          <span>
            汇款至下述账户，汇款后将在2个工作日内收到“微信支付商家助手”公众号通知，以银行到账时间为准</span
          >
        </div>
        <el-row type="flex" class="row-bg validation-text-wrap">
          <el-col :span="3">
            <div class="grid-content bg-purple">汇款金额：</div>
          </el-col>
          <el-col :span="19" style="margin-bottom: 15px">
            <div class="grid-content bg-purple-light">
              <div class="bold-text">¥{{ validationData.payAmount }}</div>
              <div>请按照指定金额汇款，验证后2个工作日内退还至账户</div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">收款卡号：</div>
          </el-col>
          <el-col :span="19" style="margin-bottom: 15px">
            <div class="grid-content bg-purple-light">
              <div class="bold-text">
                {{ validationData.destinationAccountNumber }}
              </div>
              <div>
                请汇款至上述25位卡号中，可网银汇款或柜台汇款，如汇款失败请咨询银行人员
              </div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">收款户名：</div>
          </el-col>
          <el-col :span="19" style="margin-bottom: 15px">
            <div class="grid-content bg-purple-light">
              <div class="bold-text">
                {{ validationData.destinationAccountName }}
              </div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">开户银行：</div>
          </el-col>
          <el-col :span="19" style="margin-bottom: 15px">
            <div class="grid-content bg-purple-light">
              <div class="bold-text">
                {{ validationData.destinationAccountBank }}
              </div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">省市信息：</div>
          </el-col>
          <el-col :span="19" style="margin-bottom: 15px">
            <div class="grid-content bg-purple-light">
              <div class="bold-text">{{ validationData.city }}</div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">备注信息：</div>
          </el-col>
          <el-col :span="19">
            <div class="grid-content bg-purple-light">
              <div class="bold-text">
                {{ validationData.remark ? validationData.remark : "- -" }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";
import ReviewHistory  from "../ReviewHistory.vue"

export default {
  name: "MchValidation",
  props: ["visible", "mchId"],
  components: {
    "review-history": ReviewHistory,
  },

  data() {
    return {
      validationData: {},
    };
  },

  methods: {
    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },

    initData() {
      let params = {id: this.mchId};
      let header = this.encryptionUtil.signatureParams(params, 
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_GET_MERCHANT_VALIDATION_DO,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }

        this.validationData = result.data;
        this.validationData.review.reviewHistoryList = result.data.reviewHistoryList;
      });
    },

    clearData() {
      this.validationData = {};
    }
  },
};
</script>

<style scoped>
.review-result-wrap {
  padding: 0 60px;
  margin-top: 20px;
}
.qr-code-wrap {
  margin: 20px 0;
  text-align: center;
}

.qr-code {
  width: 150px;
  height: 150px;
}

.validation-text-wrap {
  margin-top: 25px;
  padding-left: 35px;
  flex-wrap: wrap;
}

.bold-text {
  font-weight: 600;
  color: #000000;
}
</style>

<style>
.signing-qrcode-wrap {
  margin: 40px 60px;
  background: #f7f8fa;
  border: 1px solid #e6e6e6;
  padding: 22px 30px;
  color: #657180;
  font-size: 14px;
  line-height: 25px;
  text-align: left;
}

.signing-qrcode-wrap .title {
  color: #000000;
  font-weight: 600;
  margin-bottom: 10px;
}

.signing-qrcode-wrap .tag-text {
  color: #58ba37;
}
</style>



// WEBPACK FOOTER //
// src/components/review/components/mchReviewList/MchValidation.vue